const actionKeys = {
  setUserData: 'setUserData',
  forceReload: 'forceReload',
};

const set = (userData) => async (dispatch, state) => {
  dispatch({
    type: actionKeys.setUserData,
    payload: {
      ...userData,
    },
  });
};

const forceReload = () => async (dispatch) => {
  dispatch({
    type: actionKeys.forceReload,
    payload: {
      reloadRequestId: Date.now(),
    },
  });
};

const reducer = (state = {}, action) => {
  switch (action.type) {
    case actionKeys.setUserData:
      return {
        ...state,
        ...action.payload,
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.forceReload:
      return {
        ...state,
        reloadRequestId: action.payload.reloadRequestId,
      };
    default:
      return state;
  }
};


export default {
  actions: {
    set,
    forceReload,
  },
  reducer: reducer,
  defaultState: {
    lastLoadTime: null,
    reloadRequestId: null,
  },
};
